import type { AccountSummary } from "@trader/shared/Money"
import { ConfirmDialog } from "../../ui/ConfirmDialog.tsx"
import type { EndSession } from "./useEndSession.ts"

/** "End session?" (docs/design/0008): what ending does, before it does it. */
export function EndSessionDialog({ account, end }: { readonly account: AccountSummary; readonly end: EndSession }) {
  return (
    <ConfirmDialog
      title={`End ${account.name}?`}
      confirmLabel="End session"
      danger
      busy={end.busy}
      error={end.error}
      onCancel={end.cancel}
      onConfirm={end.confirm}
    >
      <p>Ending the session finishes this paper account and shows how it went:</p>
      <ul>
        <li>Open orders are cancelled.</li>
        <li>Strategies running on it are stopped (without closing their positions).</li>
        <li>Open positions stay open, valued at their last price.</li>
        <li>The account becomes read-only. Its summary stays under Ended sessions in the account picker.</li>
      </ul>
    </ConfirmDialog>
  )
}
